// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import './AdminProductsPage.css';
// import AdminNavbar from "../../Admin/Navbar/Navbar1";
// import { makeAuthenticatedGETRequest, makeAuthenticatedDELETERequest } from '../../services/serverHelper';
// import { productPoints } from '../../services/apis';
// import { useSelector } from 'react-redux'; 
// import { useSearchParams } from 'react-router-dom';
// import AdminSidebar from '../Navbar/AdminSidebar';
// import { purpose } from '../../products/ProductList';

// const AdminProductsPage = () => {
//   // State management
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [categoryFilter, setCategoryFilter] = useState('');
//   const [statusFilter, setStatusFilter] = useState('all');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [totalItems, setTotalItems] = useState(0);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [sortBy, setSortBy] = useState('-createdAt');
//   const [deleteLoading, setDeleteLoading] = useState(false);
//   const {accessToken} = useSelector(state => state.auth)
//   const [searchParams, setSearchParams] = useSearchParams();

//   // API base URL
//   const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
    
//   /**
//    * Fetch products from API
//    */
//   const fetchProducts = async (page = 1, search = '', category = '', status = 'all') => {
//     try {
//       setLoading(true);
//       setError(null);

//       // Build query parameters
//       const params = new URLSearchParams({
//         page,
//         limit: itemsPerPage,
//         sort: sortBy,
//       });

//       const searchQuery = [search, category].filter(Boolean).join(' ').trim();
//       if (searchQuery) params.append('search', searchQuery);

//       // For status filter - we'll use the isActive field
//       // all: show all, active: true, inactive: false
//       if (status === 'active') params.append('isActive', 'true');
//       if (status === 'inactive') params.append('isActive', 'false');

//       const response = await makeAuthenticatedGETRequest(
//         `${productPoints.FETCH_ALL_PRODUCTS_API_ADMIN}/?${params}`,
//         accessToken

//       )
//       console.log(response.data.products);
//       setProducts(response.data.products);
//       setTotalItems(response.data.pagination.total);
//     } catch (err) {
//       console.error('Error fetching products:', err);
//       setError('Failed to load products. Please try again later.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   /**
//    * Handle product deletion
//    */
//   const handleDeleteProduct = async () => {
//     if (!selectedProduct) return;

//     try {
//       setDeleteLoading(true);
//       await makeAuthenticatedDELETERequest(
//         `${productPoints.DELETE_PRODUCTS_API}/${selectedProduct._id}`,
//         accessToken
//       );

//       // Remove deleted product from list
//       setProducts(products.filter(p => p._id !== selectedProduct._id));
//       setTotalItems(totalItems - 1);

//       // Close modal
//       setShowDeleteModal(false);
//       setSelectedProduct(null);

//       // Show success message
//       alert('Product deleted successfully');
//     } catch (err) {
//       console.error('Error deleting product:', err);
//       alert('Failed to delete product. Please try again.');
//     } finally {
//       setDeleteLoading(false);
//     }
//   };

//   /**
//    * Handle status toggle (activate/deactivate)
//    */
//   const handleToggleStatus = async (productId, currentStatus) => {
//     try {
//       const token = localStorage.getItem('authToken');
//       if (!token) {
//         alert('Authentication required. Please log in.');
//         return;
//       }

//       const response = await axios.put(
//         `${API_BASE_URL}/api/products/${productId}`,
//         {
//           isActive: !currentStatus,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       // Update product in list
//       setProducts(
//         products.map(p =>
//           p._id === productId ? { ...p, isActive: !currentStatus } : p
//         )
//       );

//       alert(
//         `Product ${!currentStatus ? 'activated' : 'deactivated'} successfully`
//       );
//     } catch (err) {
//       console.error('Error toggling product status:', err);
//       alert('Failed to update product status. Please try again.');
//     }
//   };

//   /**
//    * Handle opening delete confirmation modal
//    */
//   const openDeleteModal = (product) => {
//     setSelectedProduct(product);
//     setShowDeleteModal(true);
//   };

//   /**
//    * Handle closing delete confirmation modal
//    */
//   const closeDeleteModal = () => {
//     setShowDeleteModal(false);
//     setSelectedProduct(null);
//   };

//   /**
//    * Handle search form submission
//    */
//   const updateSearchParams = (updates) => {
//     const params = new URLSearchParams(searchParams.toString());

//     Object.entries(updates).forEach(([key, value]) => {
//       if (value && value !== 'all') {
//         params.set(key, value);
//       } else {
//         params.delete(key);
//       }
//     });

//     setSearchParams(params);
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     setCurrentPage(1);
//     updateSearchParams({ search: searchTerm, page: '1' });
//   };

//   /**
//    * Handle filter changes
//    */
//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;

//     if (name === 'search') {
//       setSearchTerm(value);
//       updateSearchParams({ search: value, page: '1' });
//       return;
//     }

//     if (name === 'category') {
//       setCategoryFilter(value);
//       setCurrentPage(1);
//       updateSearchParams({ category: value, page: '1' });
//       return;
//     }

//     if (name === 'status') {
//       setStatusFilter(value);
//       setCurrentPage(1);
//       updateSearchParams({ status: value, page: '1' });
//       return;
//     }
//   };

//   const handleResetFilters = () => {
//     setSearchTerm('');
//     setCategoryFilter('');
//     setStatusFilter('all');
//     setCurrentPage(1);
//     setSortBy('-createdAt');
//     setItemsPerPage(10);
//     setSearchParams(new URLSearchParams());
//   };

//   /**
//    * Handle pagination
//    */
//   const handlePageChange = (newPage) => {
//     if (newPage > 0 && newPage <= Math.ceil(totalItems / itemsPerPage)) {
//       setCurrentPage(newPage);
//       fetchProducts(newPage, searchTerm, categoryFilter, statusFilter);
//     }
//   };

//   /**
//    * Handle items per page change
//    */
//   const handleItemsPerPageChange = (e) => {
//     const newLimit = parseInt(e.target.value);
//     setItemsPerPage(newLimit);
//     setCurrentPage(1);
//   };

//   /**
//    * Handle sort change
//    */
//   const handleSortChange = (e) => {
//     setSortBy(e.target.value);
//     setCurrentPage(1);
//   };

//   // Initialize from URL params and fetch products whenever query or page changes
//   useEffect(() => {
//     const initialSearch = searchParams.get('search') || '';
//     const initialCategory = searchParams.get('category') || '';
//     const initialStatus = searchParams.get('status') || 'all';
//     const initialPage = Number(searchParams.get('page')) || 1;

//     setSearchTerm(initialSearch);
//     setCategoryFilter(initialCategory);
//     setStatusFilter(initialStatus);
//     setCurrentPage(initialPage);

//     fetchProducts(initialPage, initialSearch, initialCategory, initialStatus);
//   }, [searchParams.toString(), sortBy, itemsPerPage]);

//   // Calculate pagination
//   const totalPages = Math.ceil(totalItems / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage + 1;
//   const endIndex = Math.min(currentPage * itemsPerPage, totalItems);

//   return (
//     <>
//         <AdminNavbar />
//         <div className='dashboard-layout'>
//           <AdminSidebar />
//           <div className="admin-products-page">
//           <div className="page-header">
//               <h1>Products Management</h1>
//               <p className="page-subtitle">Manage and monitor all marketplace products</p>
//           </div>

//           {/* Search and Filter Section */}
//           <div className="filters-section-admin-products">
//               <form onSubmit={handleSearch} className="search-form">
//               <div className="form-group">
//                   <input
//                   type="text"
//                   name="search"
//                   placeholder="Search by product name or description..."
//                   value={searchTerm}
//                   onChange={handleFilterChange}
//                   className="search-input"
//                   />
//                   <button type="submit" className="search-button">
//                       <span>🔍</span> Search
//                   </button>
//                   <button
//                     type="button"
//                     className="reset-button"
//                     onClick={handleResetFilters}
//                   >
//                     Reset
//                   </button>
//               </div>
//               </form>

//               <div className="filters-row">
//               <div className="filter-group">
//                   <label htmlFor="category-filter">Category:</label>
//                   <select
//                   id="category-filter"
//                   name="category"
//                   value={categoryFilter}
//                   onChange={handleFilterChange}
//                   className="filter-select"
//                   >
//                   <option value="">All Categories</option>
//                   {purpose.map((categoryItem) => (
//                     <option key={categoryItem.category} value={categoryItem.category}>
//                       {categoryItem.category}
//                     </option>
//                   ))}
//                   </select>
//               </div>

//               <div className="filter-group">
//                   <label htmlFor="status-filter">Status:</label>
//                   <select
//                   id="status-filter"
//                   name="status"
//                   value={statusFilter}
//                   onChange={handleFilterChange}
//                   className="filter-select"
//                   >
//                   <option value="all">All Status</option>
//                   <option value="active">Active</option>
//                   <option value="inactive">Inactive</option>
//                   </select>
//               </div>

//               <div className="filter-group">
//                   <label htmlFor="sort-filter">Sort By:</label>
//                   <select
//                   id="sort-filter"
//                   value={sortBy}
//                   onChange={handleSortChange}
//                   className="filter-select"
//                   >
//                   <option value="-createdAt">Newest First</option>
//                   <option value="createdAt">Oldest First</option>
//                   <option value="-pricing.amount">Price: High to Low</option>
//                   <option value="pricing.amount">Price: Low to High</option>
//                   <option value="-stats.views">Most Viewed</option>
//                   </select>
//               </div>

//               <div className="filter-group">
//                   <label htmlFor="items-per-page">Items per page:</label>
//                   <select
//                   id="items-per-page"
//                   value={itemsPerPage}
//                   onChange={handleItemsPerPageChange}
//                   className="filter-select"
//                   >
//                   <option value="5">5</option>
//                   <option value="10">10</option>
//                   <option value="25">25</option>
//                   <option value="50">50</option>
//                   </select>
//               </div>
//               </div>
//           </div>

//           {/* Error Message */}
//           {error && (
//               <div className="error-banner">
//               <span>⚠️</span> {error}
//               </div>
//           )}

//           {/* Loading State */}
//           {loading ? (
//               <div className="loading-container">
//               <div className="spinner"></div>
//               <p>Loading products...</p>
//               </div>
//           ) : products.length === 0 ? (
//               // Empty State
//               <div className="empty-state">
//               <div className="empty-icon">📦</div>
//               <h2>No Products Found</h2>
//               <p>
//                   {searchTerm || categoryFilter || statusFilter !== 'all'
//                   ? 'Try adjusting your search or filter criteria'
//                   : 'No products available at this time'}
//               </p>
//               </div>
//           ) : (
//               <>
//               {/* Products Table */}
//               <div className="table-container">
//                   <table className="products-table">
//                   <thead>
//                       <tr>
//                       <th>Product Name</th>
//                       <th>Category</th>
//                       <th>Artist</th>
//                       <th>Price</th>
//                       <th>Views</th>
//                       <th>Rating</th>
//                       <th>Status</th>
//                       <th>Created Date</th>
//                       <th>Actions</th>
//                       </tr>
//                   </thead>
//                   <tbody>
//                       {products.map((product, index) => (
//                       <tr key={product._id} className={index % 2 === 0 ? 'zebra-odd' : 'zebra-even'}>
//                           <td className="product-name-cell">
//                           <div className="product-name-content">
//                               {product.video?.thumbnail && (
//                               <img
//                                   src={product.video.thumbnail}
//                                   alt={product.title}
//                                   className="product-thumbnail"
//                               />
//                               )}
//                               <div className="product-info">
//                               <strong>{product.title}</strong>
//                               <small>{product.language}</small>
//                               </div>
//                           </div>
//                           </td>
//                           <td>
//                           <span className="category-badge">{product.category}</span>
//                           </td>
//                           <td>
//                           <span className="artist-name">
//                               {product.artist?.firstName || 'Unknown'} 
//                           </span>
//                           <span className="artist-name">
//                               {product.artist?.lastName || 'Unknown'} 
//                           </span>
//                           </td>
//                           <td className="price-cell">
//                           ₹{product.pricing?.amount?.toFixed(2) || '0.00'}
//                           </td>
//                           <td className="views-cell">{product.stats?.views || 0}</td>
//                           <td className="rating-cell">
//                           <span className="rating">
//                               {'⭐'.repeat(Math.round(product.stats?.rating || 0))}
//                               {product.stats?.rating
//                               ? ` ${product.stats.rating.toFixed(1)}`
//                               : ' No ratings'}
//                           </span>
//                           </td>
//                           <td>
//                           <button
//                               className={`status-toggle ${
//                               product.isActive ? 'active' : 'inactive'
//                               }`}
//                               onClick={() =>
//                               handleToggleStatus(product._id, product.isActive)
//                               }
//                               title={product.isActive ? 'Click to deactivate' : 'Click to activate'}
//                           >
//                               {product.isActive ? 'Active' : 'Inactive'}
//                           </button>
//                           </td>
//                           <td className="date-cell">
//                           {new Date(product.createdAt).toLocaleDateString()}
//                           </td>
//                           <td className="actions-cell">
//                           <div className="actions-group">
//                               {/* <button
//                               className="action-btn view-btn"
//                               title="View product details"
//                               onClick={() => {
//                                   // Navigate to product detail page or show details modal
//                                   console.log('View product:', product._id);
//                               }}
//                               >
//                               👁️ View
//                               </button> */}
//                               {/* <button
//                               className="action-btn edit-btn"
//                               title="Edit product"
//                               onClick={() => {
//                                   // Navigate to edit page or show edit modal
//                                   console.log('Edit product:', product._id);
//                               }}
//                               >
//                               ✏️ Edit
//                               </button> */}
//                               <button
//                                   className="action-btn delete-btn"
//                                   title="Delete product"
//                                   onClick={() => openDeleteModal(product)}
//                                   >
//                                   🗑️ Delete
//                               </button>
//                           </div>
//                           </td>
//                       </tr>
//                       ))}
//                   </tbody>
//                   </table>
//               </div>

//               {/* Pagination */}
//               <div className="pagination-section">
//                   <div className="pagination-info">
//                   Showing <strong>{startIndex}</strong> to <strong>{endIndex}</strong> of{' '}
//                   <strong>{totalItems}</strong> products
//                   </div>

//                   <div className="pagination-controls">
//                   <button
//                       className="pagination-btn"
//                       onClick={() => handlePageChange(currentPage - 1)}
//                       disabled={currentPage === 1}
//                   >
//                       ← Previous
//                   </button>

//                   <div className="page-numbers">
//                       {Array.from({ length: totalPages }, (_, i) => i + 1).map(
//                       (page) => {
//                           if (
//                           page === 1 ||
//                           page === totalPages ||
//                           (page >= currentPage - 1 && page <= currentPage + 1)
//                           ) {
//                           return (
//                               <button
//                               key={page}
//                               className={`page-number ${
//                                   page === currentPage ? 'active' : ''
//                               }`}
//                               onClick={() => handlePageChange(page)}
//                               >
//                               {page}
//                               </button>
//                           );
//                           } else if (
//                           page === currentPage - 2 ||
//                           page === currentPage + 2
//                           ) {
//                           return (
//                               <span key={page} className="page-ellipsis">
//                               ...
//                               </span>
//                           );
//                           }
//                           return null;
//                       }
//                       )}
//                   </div>

//                   <button
//                       className="pagination-btn"
//                       onClick={() => handlePageChange(currentPage + 1)}
//                       disabled={currentPage === totalPages}
//                   >
//                       Next →
//                   </button>
//                   </div>
//               </div>
//               </>
//           )}

//           {/* Delete Confirmation Modal */}
//           {showDeleteModal && (
//               <div className="modal-overlay" onClick={closeDeleteModal}>
//               <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//                   <div className="modal-header">
//                   <h2>Delete Product</h2>
//                   <button
//                       className="modal-close-btn"
//                       onClick={closeDeleteModal}
//                   >
//                       ✕
//                   </button>
//                   </div>

//                   <div className="modal-body">
//                   <div className="warning-icon">⚠️</div>
//                   <p>
//                       Are you sure you want to delete{' '}
//                       <strong>"{selectedProduct?.title}"</strong>?
//                   </p>
//                   <p className="warning-text">
//                       This action cannot be undone. The product will be permanently
//                       removed from the marketplace.
//                   </p>
//                   </div>

//                   <div className="modal-footer">
//                   <button
//                       className="modal-btn cancel-btn"
//                       onClick={closeDeleteModal}
//                       disabled={deleteLoading}
//                   >
//                       Cancel
//                   </button>
//                   <button
//                       className="modal-btn delete-confirm-btn"
//                       onClick={handleDeleteProduct}
//                       disabled={deleteLoading}
//                   >
//                       {deleteLoading ? 'Deleting...' : 'Delete Product'}
//                   </button>
//                   </div>
//               </div>
//               </div>
//           )}
//           </div>
//         </div>
//     </>
//   );
// };

// export default AdminProductsPage;






import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AdminProductsPage.css';
import AdminNavbar from "../../Admin/Navbar/Navbar1";
import { makeAuthenticatedGETRequest, makeAuthenticatedDELETERequest } from '../../services/serverHelper';
import { productPoints, partnerPoints } from '../../services/apis';
import { useSelector } from 'react-redux'; 
import { useSearchParams } from 'react-router-dom';
import AdminSidebar from '../Navbar/AdminSidebar';
import { purpose } from '../../products/ProductList';

const PARTNER_CATEGORIES = [
  "Live Performance", "Workshop", "Merchandise", "Digital Product",
  "Booking Service", "Ticketed Event", "Consultation", "Training", "Other",
];

const PARTNER_ART_SECTORS = [
  "Music", "Dance", "Theatre", "Visual Arts", "Comedy",
  "Literature", "Craft", "Mixed Arts", "Other",
];

const AdminProductsPage = () => {
  // ── Artist products state (unchanged) ──
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [sortBy, setSortBy] = useState('-createdAt');
  const [deleteLoading, setDeleteLoading] = useState(false);
  const {accessToken} = useSelector(state => state.auth)
  const [searchParams, setSearchParams] = useSearchParams();

  // ── View toggle: 'artist' | 'partnerProducts' | 'partnerServices' ──
  const [activeView, setActiveView] = useState('artist');

  // ── Partner offerings state ──
  const [partnerItems, setPartnerItems] = useState([]);
  const [partnerLoading, setPartnerLoading] = useState(false);
  const [partnerError, setPartnerError] = useState(null);
  const [partnerSearchTerm, setPartnerSearchTerm] = useState('');
  const [partnerCategoryFilter, setPartnerCategoryFilter] = useState('');
  const [partnerArtSectorFilter, setPartnerArtSectorFilter] = useState('');
  const [partnerStatusFilter, setPartnerStatusFilter] = useState('All');
  const [partnerStockFilter, setPartnerStockFilter] = useState('All'); // products only
  const [partnerCurrentPage, setPartnerCurrentPage] = useState(1);
  const [partnerItemsPerPage, setPartnerItemsPerPage] = useState(10);
  const [partnerTotalItems, setPartnerTotalItems] = useState(0);
  const [partnerDeleteModalOpen, setPartnerDeleteModalOpen] = useState(false);
  const [selectedPartnerItem, setSelectedPartnerItem] = useState(null);
  const [partnerDeleteLoading, setPartnerDeleteLoading] = useState(false);

  // API base URL
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

  const offeringKindForView = (view) =>
    view === 'partnerProducts' ? 'Product' : view === 'partnerServices' ? 'Service' : null;

  /**
   * Fetch products from API (artist products - unchanged)
   */
  const fetchProducts = async (page = 1, search = '', category = '', status = 'all') => {
    try {
      setLoading(true);
      setError(null);

      // Build query parameters
      const params = new URLSearchParams({
        page,
        limit: itemsPerPage,
        sort: sortBy,
      });

      const searchQuery = [search, category].filter(Boolean).join(' ').trim();
      if (searchQuery) params.append('search', searchQuery);

      // For status filter - we'll use the isActive field
      // all: show all, active: true, inactive: false
      if (status === 'active') params.append('isActive', 'true');
      if (status === 'inactive') params.append('isActive', 'false');

      const response = await makeAuthenticatedGETRequest(
        `${productPoints.FETCH_ALL_PRODUCTS_API_ADMIN}/?${params}`,
        accessToken

      )
      console.log(response.data.products);
      setProducts(response.data.products);
      setTotalItems(response.data.pagination.total);
    } catch (err) {
      console.error('Error fetching products:', err);
      setError('Failed to load products. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  /**
   * Handle product deletion (artist products - unchanged)
   */
  const handleDeleteProduct = async () => {
    if (!selectedProduct) return;

    try {
      setDeleteLoading(true);
      await makeAuthenticatedDELETERequest(
        `${productPoints.DELETE_PRODUCTS_API}/${selectedProduct._id}`,
        accessToken
      );

      // Remove deleted product from list
      setProducts(products.filter(p => p._id !== selectedProduct._id));
      setTotalItems(totalItems - 1);

      // Close modal
      setShowDeleteModal(false);
      setSelectedProduct(null);

      // Show success message
      alert('Product deleted successfully');
    } catch (err) {
      console.error('Error deleting product:', err);
      alert('Failed to delete product. Please try again.');
    } finally {
      setDeleteLoading(false);
    }
  };

  /**
   * Handle status toggle (activate/deactivate) (artist products - unchanged)
   */
  const handleToggleStatus = async (productId, currentStatus) => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        alert('Authentication required. Please log in.');
        return;
      }

      const response = await axios.put(
        `${API_BASE_URL}/api/products/${productId}`,
        {
          isActive: !currentStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Update product in list
      setProducts(
        products.map(p =>
          p._id === productId ? { ...p, isActive: !currentStatus } : p
        )
      );

      alert(
        `Product ${!currentStatus ? 'activated' : 'deactivated'} successfully`
      );
    } catch (err) {
      console.error('Error toggling product status:', err);
      alert('Failed to update product status. Please try again.');
    }
  };

  /**
   * Handle opening delete confirmation modal (artist products - unchanged)
   */
  const openDeleteModal = (product) => {
    setSelectedProduct(product);
    setShowDeleteModal(true);
  };

  /**
   * Handle closing delete confirmation modal (artist products - unchanged)
   */
  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedProduct(null);
  };

  /**
   * Handle search form submission (artist products - unchanged)
   */
  const updateSearchParams = (updates) => {
    const params = new URLSearchParams(searchParams.toString());

    Object.entries(updates).forEach(([key, value]) => {
      if (value && value !== 'all') {
        params.set(key, value);
      } else {
        params.delete(key);
      }
    });

    setSearchParams(params);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    updateSearchParams({ search: searchTerm, page: '1' });
  };

  /**
   * Handle filter changes (artist products - unchanged)
   */
  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    if (name === 'search') {
      setSearchTerm(value);
      updateSearchParams({ search: value, page: '1' });
      return;
    }

    if (name === 'category') {
      setCategoryFilter(value);
      setCurrentPage(1);
      updateSearchParams({ category: value, page: '1' });
      return;
    }

    if (name === 'status') {
      setStatusFilter(value);
      setCurrentPage(1);
      updateSearchParams({ status: value, page: '1' });
      return;
    }
  };

  const handleResetFilters = () => {
    setSearchTerm('');
    setCategoryFilter('');
    setStatusFilter('all');
    setCurrentPage(1);
    setSortBy('-createdAt');
    setItemsPerPage(10);
    setSearchParams(new URLSearchParams());
  };

  /**
   * Handle pagination (artist products - unchanged)
   */
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= Math.ceil(totalItems / itemsPerPage)) {
      setCurrentPage(newPage);
      fetchProducts(newPage, searchTerm, categoryFilter, statusFilter);
    }
  };

  /**
   * Handle items per page change (artist products - unchanged)
   */
  const handleItemsPerPageChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setItemsPerPage(newLimit);
    setCurrentPage(1);
  };

  /**
   * Handle sort change (artist products - unchanged)
   */
  const handleSortChange = (e) => {
    setSortBy(e.target.value);
    setCurrentPage(1);
  };

  // Initialize from URL params and fetch products whenever query or page changes
  useEffect(() => {
    const initialSearch = searchParams.get('search') || '';
    const initialCategory = searchParams.get('category') || '';
    const initialStatus = searchParams.get('status') || 'all';
    const initialPage = Number(searchParams.get('page')) || 1;

    setSearchTerm(initialSearch);
    setCategoryFilter(initialCategory);
    setStatusFilter(initialStatus);
    setCurrentPage(initialPage);

    fetchProducts(initialPage, initialSearch, initialCategory, initialStatus);
  }, [searchParams.toString(), sortBy, itemsPerPage]);

  // Calculate pagination (artist products - unchanged)
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage + 1;
  const endIndex = Math.min(currentPage * itemsPerPage, totalItems);

  /**
   * Fetch partner offerings (products or services) from API
   */
  const fetchPartnerOfferings = async (kind, page = 1) => {
    try {
      setPartnerLoading(true);
      setPartnerError(null);

      const params = new URLSearchParams({
        offeringKind: kind,
        page,
        limit: partnerItemsPerPage,
      });

      if (partnerSearchTerm) params.append('search', partnerSearchTerm);
      if (partnerCategoryFilter) params.append('category', partnerCategoryFilter);
      if (partnerArtSectorFilter) params.append('artSector', partnerArtSectorFilter);
      if (partnerStatusFilter !== 'All') params.append('status', partnerStatusFilter);
      if (kind === 'Product' && partnerStockFilter !== 'All') {
        params.append('stock', partnerStockFilter);
      }

      const response = await makeAuthenticatedGETRequest(
        `${partnerPoints.FETCH_PARTNER_OFFERINGS_API}/?${params}`,
        accessToken
      );

      setPartnerItems(response.data.products);
      setPartnerTotalItems(response.data.pagination.total);
    } catch (err) {
      console.error('Error fetching partner offerings:', err);
      setPartnerError('Failed to load partner listings. Please try again later.');
    } finally {
      setPartnerLoading(false);
    }
  };

  // Fetch partner offerings whenever the active partner view or its filters/page change
  useEffect(() => {
    const kind = offeringKindForView(activeView);
    if (kind) {
      fetchPartnerOfferings(kind, partnerCurrentPage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    activeView,
    partnerCurrentPage,
    partnerItemsPerPage,
    partnerCategoryFilter,
    partnerArtSectorFilter,
    partnerStatusFilter,
    partnerStockFilter,
  ]);

  const handlePartnerSearchSubmit = (e) => {
    e.preventDefault();
    setPartnerCurrentPage(1);
    fetchPartnerOfferings(offeringKindForView(activeView), 1);
  };

  const handlePartnerFilterChange = (setter) => (e) => {
    setter(e.target.value);
    setPartnerCurrentPage(1);
  };

  const handleResetPartnerFilters = () => {
    setPartnerSearchTerm('');
    setPartnerCategoryFilter('');
    setPartnerArtSectorFilter('');
    setPartnerStatusFilter('All');
    setPartnerStockFilter('All');
    setPartnerCurrentPage(1);
  };

  const openPartnerDeleteModal = (item) => {
    setSelectedPartnerItem(item);
    setPartnerDeleteModalOpen(true);
  };

  const closePartnerDeleteModal = () => {
    setPartnerDeleteModalOpen(false);
    setSelectedPartnerItem(null);
  };

  const handleDeletePartnerItem = async () => {
    if (!selectedPartnerItem) return;

    try {
      setPartnerDeleteLoading(true);
      await makeAuthenticatedDELETERequest(
        `${partnerPoints.FETCH_PARTNER_OFFERINGS_API}/${selectedPartnerItem._id}`,
        accessToken
      );

      setPartnerItems(partnerItems.filter(p => p._id !== selectedPartnerItem._id));
      setPartnerTotalItems(partnerTotalItems - 1);

      closePartnerDeleteModal();
      alert(`${selectedPartnerItem.offeringKind || 'Item'} deleted successfully`);
    } catch (err) {
      console.error('Error deleting partner item:', err);
      alert('Failed to delete. Please try again.');
    } finally {
      setPartnerDeleteLoading(false);
    }
  };

  const handlePartnerItemsPerPageChange = (e) => {
    setPartnerItemsPerPage(parseInt(e.target.value));
    setPartnerCurrentPage(1);
  };

  const partnerTotalPages = Math.ceil(partnerTotalItems / partnerItemsPerPage);
  const partnerStartIndex = (partnerCurrentPage - 1) * partnerItemsPerPage + 1;
  const partnerEndIndex = Math.min(partnerCurrentPage * partnerItemsPerPage, partnerTotalItems);

  const handlePartnerPageChange = (newPage) => {
    if (newPage > 0 && newPage <= partnerTotalPages) {
      setPartnerCurrentPage(newPage);
    }
  };

  return (
    <>
        <AdminNavbar />
        <div className='dashboard-layout'>
          <AdminSidebar />
          <div className="admin-products-page">
          <div className="page-header">
              <h1>Products Management</h1>
              <p className="page-subtitle">Manage and monitor all marketplace products</p>
          </div>

          {/* View Toggle */}
          <div className="view-toggle-row">
            <button
              className={`view-toggle-btn ${activeView === 'artist' ? 'active' : ''}`}
              onClick={() => setActiveView('artist')}
            >
              Artist Products
            </button>
            <button
              className={`view-toggle-btn ${activeView === 'partnerProducts' ? 'active' : ''}`}
              onClick={() => setActiveView('partnerProducts')}
            >
              Partner Products
            </button>
            <button
              className={`view-toggle-btn ${activeView === 'partnerServices' ? 'active' : ''}`}
              onClick={() => setActiveView('partnerServices')}
            >
              Partner Services
            </button>
          </div>

          {/* ===================== ARTIST PRODUCTS VIEW ===================== */}
          {activeView === 'artist' && (
            <>
              {/* Search and Filter Section */}
              <div className="filters-section-admin-products">
                  <form onSubmit={handleSearch} className="search-form">
                  <div className="form-group">
                      <input
                      type="text"
                      name="search"
                      placeholder="Search by product name or description..."
                      value={searchTerm}
                      onChange={handleFilterChange}
                      className="search-input"
                      />
                      <button type="submit" className="search-button">
                          <span>🔍</span> Search
                      </button>
                      <button
                        type="button"
                        className="reset-button"
                        onClick={handleResetFilters}
                      >
                        Reset
                      </button>
                  </div>
                  </form>

                  <div className="filters-row">
                  <div className="filter-group">
                      <label htmlFor="category-filter">Category:</label>
                      <select
                      id="category-filter"
                      name="category"
                      value={categoryFilter}
                      onChange={handleFilterChange}
                      className="filter-select"
                      >
                      <option value="">All Categories</option>
                      {purpose.map((categoryItem) => (
                        <option key={categoryItem.category} value={categoryItem.category}>
                          {categoryItem.category}
                        </option>
                      ))}
                      </select>
                  </div>

                  <div className="filter-group">
                      <label htmlFor="status-filter">Status:</label>
                      <select
                      id="status-filter"
                      name="status"
                      value={statusFilter}
                      onChange={handleFilterChange}
                      className="filter-select"
                      >
                      <option value="all">All Status</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                      </select>
                  </div>

                  <div className="filter-group">
                      <label htmlFor="sort-filter">Sort By:</label>
                      <select
                      id="sort-filter"
                      value={sortBy}
                      onChange={handleSortChange}
                      className="filter-select"
                      >
                      <option value="-createdAt">Newest First</option>
                      <option value="createdAt">Oldest First</option>
                      <option value="-pricing.amount">Price: High to Low</option>
                      <option value="pricing.amount">Price: Low to High</option>
                      <option value="-stats.views">Most Viewed</option>
                      </select>
                  </div>

                  <div className="filter-group">
                      <label htmlFor="items-per-page">Items per page:</label>
                      <select
                      id="items-per-page"
                      value={itemsPerPage}
                      onChange={handleItemsPerPageChange}
                      className="filter-select"
                      >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      </select>
                  </div>
                  </div>
              </div>

              {/* Error Message */}
              {error && (
                  <div className="error-banner">
                  <span>⚠️</span> {error}
                  </div>
              )}

              {/* Loading State */}
              {loading ? (
                  <div className="loading-container">
                  <div className="spinner"></div>
                  <p>Loading products...</p>
                  </div>
              ) : products.length === 0 ? (
                  // Empty State
                  <div className="empty-state">
                  <div className="empty-icon">📦</div>
                  <h2>No Products Found</h2>
                  <p>
                      {searchTerm || categoryFilter || statusFilter !== 'all'
                      ? 'Try adjusting your search or filter criteria'
                      : 'No products available at this time'}
                  </p>
                  </div>
              ) : (
                  <>
                  {/* Products Table */}
                  <div className="table-container">
                      <table className="products-table">
                      <thead>
                          <tr>
                          <th>Product Name</th>
                          <th>Category</th>
                          <th>Artist</th>
                          <th>Price</th>
                          <th>Views</th>
                          <th>Rating</th>
                          <th>Status</th>
                          <th>Created Date</th>
                          <th>Actions</th>
                          </tr>
                      </thead>
                      <tbody>
                          {products.map((product, index) => (
                          <tr key={product._id} className={index % 2 === 0 ? 'zebra-odd' : 'zebra-even'}>
                              <td className="product-name-cell">
                              <div className="product-name-content">
                                  {product.video?.thumbnail && (
                                  <img
                                      src={product.video.thumbnail}
                                      alt={product.title}
                                      className="product-thumbnail"
                                  />
                                  )}
                                  <div className="product-info">
                                  <strong>{product.title}</strong>
                                  <small>{product.language}</small>
                                  </div>
                              </div>
                              </td>
                              <td>
                              <span className="category-badge">{product.category}</span>
                              </td>
                              <td>
                              <span className="artist-name">
                                  {product.artist?.firstName || 'Unknown'} 
                              </span>
                              <span className="artist-name">
                                  {product.artist?.lastName || 'Unknown'} 
                              </span>
                              </td>
                              <td className="price-cell">
                              ₹{product.pricing?.amount?.toFixed(2) || '0.00'}
                              </td>
                              <td className="views-cell">{product.stats?.views || 0}</td>
                              <td className="rating-cell">
                              <span className="rating">
                                  {'⭐'.repeat(Math.round(product.stats?.rating || 0))}
                                  {product.stats?.rating
                                  ? ` ${product.stats.rating.toFixed(1)}`
                                  : ' No ratings'}
                              </span>
                              </td>
                              <td>
                              <button
                                  className={`status-toggle ${
                                  product.isActive ? 'active' : 'inactive'
                                  }`}
                                  onClick={() =>
                                  handleToggleStatus(product._id, product.isActive)
                                  }
                                  title={product.isActive ? 'Click to deactivate' : 'Click to activate'}
                              >
                                  {product.isActive ? 'Active' : 'Inactive'}
                              </button>
                              </td>
                              <td className="date-cell">
                              {new Date(product.createdAt).toLocaleDateString()}
                              </td>
                              <td className="actions-cell">
                              <div className="actions-group">
                                  {/* <button
                                  className="action-btn view-btn"
                                  title="View product details"
                                  onClick={() => {
                                      // Navigate to product detail page or show details modal
                                      console.log('View product:', product._id);
                                  }}
                                  >
                                  👁️ View
                                  </button> */}
                                  {/* <button
                                  className="action-btn edit-btn"
                                  title="Edit product"
                                  onClick={() => {
                                      // Navigate to edit page or show edit modal
                                      console.log('Edit product:', product._id);
                                  }}
                                  >
                                  ✏️ Edit
                                  </button> */}
                                  <button
                                      className="action-btn delete-btn"
                                      title="Delete product"
                                      onClick={() => openDeleteModal(product)}
                                      >
                                      🗑️ Delete
                                  </button>
                              </div>
                              </td>
                          </tr>
                          ))}
                      </tbody>
                      </table>
                  </div>

                  {/* Pagination */}
                  <div className="pagination-section">
                      <div className="pagination-info">
                      Showing <strong>{startIndex}</strong> to <strong>{endIndex}</strong> of{' '}
                      <strong>{totalItems}</strong> products
                      </div>

                      <div className="pagination-controls">
                      <button
                          className="pagination-btn"
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                      >
                          ← Previous
                      </button>

                      <div className="page-numbers">
                          {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                          (page) => {
                              if (
                              page === 1 ||
                              page === totalPages ||
                              (page >= currentPage - 1 && page <= currentPage + 1)
                              ) {
                              return (
                                  <button
                                  key={page}
                                  className={`page-number ${
                                      page === currentPage ? 'active' : ''
                                  }`}
                                  onClick={() => handlePageChange(page)}
                                  >
                                  {page}
                                  </button>
                              );
                              } else if (
                              page === currentPage - 2 ||
                              page === currentPage + 2
                              ) {
                              return (
                                  <span key={page} className="page-ellipsis">
                                  ...
                                  </span>
                              );
                              }
                              return null;
                          }
                          )}
                      </div>

                      <button
                          className="pagination-btn"
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                      >
                          Next →
                      </button>
                      </div>
                  </div>
                  </>
              )}
            </>
          )}

          {/* ===================== PARTNER PRODUCTS / SERVICES VIEW ===================== */}
          {(activeView === 'partnerProducts' || activeView === 'partnerServices') && (
            <>
              <div className="filters-section-admin-products">
                <form onSubmit={handlePartnerSearchSubmit} className="search-form">
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Search by name, code, or description..."
                      value={partnerSearchTerm}
                      onChange={(e) => setPartnerSearchTerm(e.target.value)}
                      className="search-input"
                    />
                    <button type="submit" className="search-button">
                      <span>🔍</span> Search
                    </button>
                    <button
                      type="button"
                      className="reset-button"
                      onClick={handleResetPartnerFilters}
                    >
                      Reset
                    </button>
                  </div>
                </form>

                <div className="filters-row">
                  <div className="filter-group">
                    <label htmlFor="partner-category-filter">Category:</label>
                    <select
                      id="partner-category-filter"
                      className="filter-select"
                      value={partnerCategoryFilter}
                      onChange={handlePartnerFilterChange(setPartnerCategoryFilter)}
                    >
                      <option value="">All Categories</option>
                      {PARTNER_CATEGORIES.map((c) => (
                        <option key={c} value={c}>{c}</option>
                      ))}
                    </select>
                  </div>

                  <div className="filter-group">
                    <label htmlFor="partner-artsector-filter">Art Sector:</label>
                    <select
                      id="partner-artsector-filter"
                      className="filter-select"
                      value={partnerArtSectorFilter}
                      onChange={handlePartnerFilterChange(setPartnerArtSectorFilter)}
                    >
                      <option value="">All Sectors</option>
                      {PARTNER_ART_SECTORS.map((s) => (
                        <option key={s} value={s}>{s}</option>
                      ))}
                    </select>
                  </div>

                  <div className="filter-group">
                    <label htmlFor="partner-status-filter">Status:</label>
                    <select
                      id="partner-status-filter"
                      className="filter-select"
                      value={partnerStatusFilter}
                      onChange={handlePartnerFilterChange(setPartnerStatusFilter)}
                    >
                      <option value="All">All Status</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                      <option value="Draft">Draft</option>
                    </select>
                  </div>

                  {activeView === 'partnerProducts' && (
                    <div className="filter-group">
                      <label htmlFor="partner-stock-filter">Stock:</label>
                      <select
                        id="partner-stock-filter"
                        className="filter-select"
                        value={partnerStockFilter}
                        onChange={handlePartnerFilterChange(setPartnerStockFilter)}
                      >
                        <option value="All">All Stock</option>
                        <option value="In Stock">In Stock</option>
                        <option value="Low Stock">Low Stock</option>
                        <option value="Out of Stock">Out of Stock</option>
                      </select>
                    </div>
                  )}

                  <div className="filter-group">
                    <label htmlFor="partner-items-per-page">Items per page:</label>
                    <select
                      id="partner-items-per-page"
                      className="filter-select"
                      value={partnerItemsPerPage}
                      onChange={handlePartnerItemsPerPageChange}
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                </div>
              </div>

              {partnerError && (
                <div className="error-banner">
                  <span>⚠️</span> {partnerError}
                </div>
              )}

              {partnerLoading ? (
                <div className="loading-container">
                  <div className="spinner"></div>
                  <p>Loading {activeView === 'partnerProducts' ? 'products' : 'services'}...</p>
                </div>
              ) : partnerItems.length === 0 ? (
                <div className="empty-state">
                  <div className="empty-icon">📦</div>
                  <h2>No {activeView === 'partnerProducts' ? 'Products' : 'Services'} Found</h2>
                  <p>
                    {partnerSearchTerm || partnerCategoryFilter || partnerArtSectorFilter || partnerStatusFilter !== 'All'
                      ? 'Try adjusting your search or filter criteria'
                      : 'No listings available at this time'}
                  </p>
                </div>
              ) : (
                <>
                  <div className="table-container">
                    <table className="products-table">
                      <thead>
                        <tr>
                          <th>Name / Code</th>
                          <th>Partner</th>
                          <th>Category</th>
                          <th>Art Sector</th>
                          <th>Price</th>
                          {activeView === 'partnerProducts' ? <th>Stock</th> : <th>Duration</th>}
                          <th>Status</th>
                          <th>Created Date</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {partnerItems.map((item, index) => (
                          <tr key={item._id} className={index % 2 === 0 ? 'zebra-odd' : 'zebra-even'}>
                            <td className="product-name-cell">
                              <div className="product-info">
                                <strong>{item.name}</strong>
                                <small>{item.code}</small>
                              </div>
                            </td>
                            <td>
                              <span className="artist-name">
                                {item.partner?.agencyName || item.partner || 'N/A'}
                              </span>
                            </td>
                            <td>
                              <span className="category-badge">{item.category}</span>
                            </td>
                            <td>{item.artSector}</td>
                            <td className="price-cell">
                              ₹{Number(item.price || 0).toFixed(2)}
                            </td>
                            {activeView === 'partnerProducts' ? (
                              <td className="views-cell">{item.stockQuantity ?? 0}</td>
                            ) : (
                              <td className="views-cell">{item.duration || '—'}</td>
                            )}
                            <td>
                              <span
                                className={`status-toggle ${
                                  item.status === 'Active' ? 'active' : 'inactive'
                                }`}
                              >
                                {item.status}
                              </span>
                            </td>
                            <td className="date-cell">
                              {new Date(item.createdAt).toLocaleDateString()}
                            </td>
                            <td className="actions-cell">
                              <div className="actions-group">
                                <button
                                  className="action-btn delete-btn"
                                  title="Delete"
                                  onClick={() => openPartnerDeleteModal(item)}
                                >
                                  🗑️ Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="pagination-section">
                    <div className="pagination-info">
                      Showing <strong>{partnerStartIndex}</strong> to <strong>{partnerEndIndex}</strong> of{' '}
                      <strong>{partnerTotalItems}</strong> {activeView === 'partnerProducts' ? 'products' : 'services'}
                    </div>

                    <div className="pagination-controls">
                      <button
                        className="pagination-btn"
                        onClick={() => handlePartnerPageChange(partnerCurrentPage - 1)}
                        disabled={partnerCurrentPage === 1}
                      >
                        ← Previous
                      </button>

                      <div className="page-numbers">
                        {Array.from({ length: partnerTotalPages }, (_, i) => i + 1).map((page) => {
                          if (
                            page === 1 ||
                            page === partnerTotalPages ||
                            (page >= partnerCurrentPage - 1 && page <= partnerCurrentPage + 1)
                          ) {
                            return (
                              <button
                                key={page}
                                className={`page-number ${page === partnerCurrentPage ? 'active' : ''}`}
                                onClick={() => handlePartnerPageChange(page)}
                              >
                                {page}
                              </button>
                            );
                          } else if (
                            page === partnerCurrentPage - 2 ||
                            page === partnerCurrentPage + 2
                          ) {
                            return (
                              <span key={page} className="page-ellipsis">
                                ...
                              </span>
                            );
                          }
                          return null;
                        })}
                      </div>

                      <button
                        className="pagination-btn"
                        onClick={() => handlePartnerPageChange(partnerCurrentPage + 1)}
                        disabled={partnerCurrentPage === partnerTotalPages}
                      >
                        Next →
                      </button>
                    </div>
                  </div>
                </>
              )}
            </>
          )}

          {/* Delete Confirmation Modal (artist products) */}
          {showDeleteModal && (
              <div className="modal-overlay" onClick={closeDeleteModal}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-header">
                  <h2>Delete Product</h2>
                  <button
                      className="modal-close-btn"
                      onClick={closeDeleteModal}
                  >
                      ✕
                  </button>
                  </div>

                  <div className="modal-body">
                  <div className="warning-icon">⚠️</div>
                  <p>
                      Are you sure you want to delete{' '}
                      <strong>"{selectedProduct?.title}"</strong>?
                  </p>
                  <p className="warning-text">
                      This action cannot be undone. The product will be permanently
                      removed from the marketplace.
                  </p>
                  </div>

                  <div className="modal-footer">
                  <button
                      className="modal-btn cancel-btn"
                      onClick={closeDeleteModal}
                      disabled={deleteLoading}
                  >
                      Cancel
                  </button>
                  <button
                      className="modal-btn delete-confirm-btn"
                      onClick={handleDeleteProduct}
                      disabled={deleteLoading}
                  >
                      {deleteLoading ? 'Deleting...' : 'Delete Product'}
                  </button>
                  </div>
              </div>
              </div>
          )}

          {/* Delete Confirmation Modal (partner products/services) */}
          {partnerDeleteModalOpen && (
            <div className="modal-overlay" onClick={closePartnerDeleteModal}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h2>Delete {selectedPartnerItem?.offeringKind || 'Item'}</h2>
                  <button
                    className="modal-close-btn"
                    onClick={closePartnerDeleteModal}
                  >
                    ✕
                  </button>
                </div>

                <div className="modal-body">
                  <div className="warning-icon">⚠️</div>
                  <p>
                    Are you sure you want to delete{' '}
                    <strong>"{selectedPartnerItem?.name}"</strong>?
                  </p>
                  <p className="warning-text">
                    This action cannot be undone. The listing will be permanently
                    removed from the marketplace.
                  </p>
                </div>

                <div className="modal-footer">
                  <button
                    className="modal-btn cancel-btn"
                    onClick={closePartnerDeleteModal}
                    disabled={partnerDeleteLoading}
                  >
                    Cancel
                  </button>
                  <button
                    className="modal-btn delete-confirm-btn"
                    onClick={handleDeletePartnerItem}
                    disabled={partnerDeleteLoading}
                  >
                    {partnerDeleteLoading ? 'Deleting...' : 'Delete'}
                  </button>
                </div>
              </div>
            </div>
          )}
          </div>
        </div>
    </>
  );
};

export default AdminProductsPage;